import { css } from 'styled-components';

export const general = css`
    --box-shadow-none: none;
    --box-shadow-sm: 0px 2px 4px rgba(113, 117, 134, 0.45);;
    --box-shadow-md: 0px 4px 12px rgba(113, 117, 134, 0.45);;
    --box-shadow-lg: 0px 8px 24px rgba(113, 117, 134, 0.45);;

    --border-radius-sm: 0.25rem;
    --border-radius-md: 0.5rem;
    --border-radius-lg: 1rem;
    --border-radius-xl: 2rem;

    --space-ss: 0.125rem;   // 2px
    --space-xxs: 0.25rem;    // 4px
    --space-xs: 0.5rem;      // 8px
    --space-sm: 0.75rem;     // 12px
    --space-md: 1rem;        // 16px
    --space-lg: 1.5rem;      // 24px
    --space-2lg: 2rem;      // 32px
    --space-xl: 2.5rem;      // 40px
    --space-xxl: 3rem;       // 48px
    --space-3xl: 3.5rem;       // 56px

    --z-index-below: -1;
    --z-index-base: 0;
    --z-index-above: 1;
`;
